<template>
	<div style="position: relative;">
		<mylogin flag="0"></mylogin>
		<div style="width: 1200px;margin: 0 auto;display: flex;justify-content: flex-end;">
			<div class="mycon1">
				<p class="mycon-p">用户注册</p>
				<input type="text" class="mycon-input" placeholder="请输入手机号" v-model="phoneNum" />
				<input type="text" class="mycon-input1" placeholder="输入账号" v-model="username" />
				<input type="password" class="mycon-input1" placeholder="输入密码" v-model="password" />
				<input type="password" class="mycon-input1" placeholder="确认密码" v-model="repassword" />
				<div class="mycon-con">
					<input type="text" class="mycon-con-input" placeholder="请输入验证码" v-model="captcha" />
					<button type="button" class="mycon-con-btn" @click="getCode">
						<span v-show="show">获取验证码</span>
						<span v-show="!show" class="count">重新获取{{count}} s</span>
					</button>
				</div>
				<button class="mycon-btn" @click="toRegister">注册</button>
				<p class="mycon-p1" v-if="ckphone">* 请输入正确手机号/手机格式错误</p>
				<p class="mycon-p1" v-if="ckpassword">* 密码不足六位数</p>
				<p class="mycon-p1" v-if="nikenamelength">* 昵称长度4-12之间</p>
				<p class="mycon-p1" v-if="nopassword">* 密码不一致</p>
				<p class="mycon-p1" v-if="ckcaptcha">* 验证码错误</p>
			</div>
		</div>
	</div>
</template>

<script>
	import mylogin from "../mylogin.vue";

	export default {
		name: "App",
		components: {
			mylogin
		},
		data() {
			return {
				show: true,
				count: "",
				timer: null,
				phoneNum: "",
				username: "",
				password: "",
				repassword: "",
				captcha: "",
				ckphone: false,
				ckpassword: false,
				ckcaptcha: false,
				nikenamelength: false,
				nopassword: false
			};
		},
		methods: {
			getCode() {
				if (this.show) {
					this.$http
						.post("sms/send", {
							mobile: this.phoneNum,
							event: "register"
						})
						.then(res => {
							console.log("验证码", res.body);
							if (res.body.code == 0) {
								this.ckphone = true;
							}
							if (res.body.code == 1) {
								this.ckphone = false;
								const TIME_COUNT = 60;
								if (!this.timer) {
									this.count = TIME_COUNT;
									this.show = false;
									this.timer = setInterval(() => {
										if (this.count > 0 && this.count <= TIME_COUNT) {
											this.count--;
										} else {
											this.show = true;
											clearInterval(this.timer);
											this.timer = null;
										}
									}, 1000);
								}
							}
						});
				}
			},
			toRegister() {
				// 判断手机号格式
				(this.ckphone = false),
					(this.ckpassword = false),
					(this.nopassword = false),
					(this.nikenamelength = false),
					(this.ckcaptcha = false);
				var ckPhone = /^[1][3,4,5,7,8,9][0-9]{9}$/;
				if (!ckPhone.test(this.phoneNum)) {
					console.log("手机号格式不正确");
					this.ckphone = true;
					return;
				}
				if (this.username.length < 4 || this.username.length > 12) {
					console.log("昵称格式不正确");
					this.nikenamelength = true;
					return;
				}
				if (this.password.length < 6 || this.password.length > 16) {
					console.log("密码格式不正确");
					this.ckpassword = true;
					return;
				}
				if (this.password != this.repassword) {
					console.log("密码不一致");
					this.nopassword = true;
					return;
				}
				this.$http
					.post("user/register", {
						mobile: this.phoneNum,
						password: this.password,
						repassword: this.repassword,
						username: this.username,
						captcha: this.captcha
					})
					.then(res => {
						console.log("注册", res);
						if (res.body.code == 1) {
							this.$router.push("/Registration");
							// 差获取token
						} else if (res.body.code == 0) {
							this.ckcaptcha = true;
						}
					});
			}
		}
	};
</script>

<style>
	.mycon1 {
		width: 400px;
		height: 561px;
		margin-top: 95px;
		padding: 30px;
		box-sizing: border-box;
		background-color: #f5f5f5;
		position: absolute;
		top: 40px;
	}

	.mycon-p {
		text-align: center;
		font-size: 16px;
		color: #212121;
	}

	.mycon-input {
		width: 100%;
		height: 40px;
		margin-top: 40px;
		border-radius: 6px;
		box-sizing: border-box;
		border: 1px solid #b4b4b4;
		font-size: 16px;
		padding-left: 5px;
	}

	.mycon-input1 {
		width: 100%;
		height: 40px;
		margin-top: 20px;
		border-radius: 6px;
		box-sizing: border-box;
		border: 1px solid #b4b4b4;
		font-size: 16px;
		padding-left: 5px;
	}

	.mycon-con {
		width: 100%;
		height: 40px;
		display: flex;
		margin-top: 20px;
		justify-content: space-between;
	}

	.mycon-con-input {
		width: 190px;
		height: 40px;
		border-radius: 6px;
		box-sizing: border-box;
		border: 1px solid #b4b4b4;
		font-size: 16px;
		padding-left: 5px;
	}

	.mycon-con-btn {
		width: 130px;
		height: 40px;
		border: 1px solid #6bccd5;
		color: #6bccd5;
		border-radius: 6px;
		background-color: #fff;
		font-size: 16px;
	}

	.mycon-btn {
		width: 100%;
		height: 40px;
		border-radius: 6px;
		border: 0;
		background-color: #6bccd5;
		color: #fff;
		font-size: 16px;
		margin-top: 20px;
	}

	.mycon-p1 {
		font-size: 12px;
		color: #d10000;
		margin-top: 20px;
	}

	.mycon-div {
		width: 100%;
		margin-top: 20px;
		display: flex;
		justify-content: flex-end;
	}

	.mycon-div-p {
		font-size: 12px;
		color: #212121;
		margin-left: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/components/login/register.vue